export class SendAttachmentsToCustomerModel {
    
    requestId: number;
    comment: string;
    attachmentIds: number[] = [];
    force: boolean;
}